/**
 *Created by jmmartinez on 22/10/19
 *  v 1.1 24/10/2019 Añadida propiedad focusInicialLlamado para solo hacer el setFocus la primera vez.
 *  v 1.2 25/10/2019 Añadida función para añadir componentes al TabOrder
 *  v 1.3 31/10/2019 Añadida función getRefSiguienteNoNull para saltar los nulos.
 *  v 1.4 05/11/2019 Modificado constructor para comprobar existencia de parametro.
 *                   Nueva función generarTabOrdersDeCamposBusqueda.
 */

import React from "react";
import {filtrarConNombreCampo} from "./FilterUtils";


class TabOrderManager {

    constructor(elementoConfig) {
        if (elementoConfig)
            this.tabOrders = this.generarTabOrders(elementoConfig);
        else
            this.tabOrders = [];
        this.focusInicialLlamado= false;
    }

    log= () => {
        console.log("TABORDERMANAGER tabOrders");
        console.log(this.tabOrders);
    }

    addTabOrder= (campo, tabOrder) => {
        this.tabOrders.push({
            tabOrder: tabOrder ? tabOrder : this.tabOrders.length,
            campoNombre: campo,
            ref: React.createRef()
        });
    }

    generarTabOrders= (elementoConfig) => {
        let tabOrders = [];
        elementoConfig.campos.forEach( (campo, index) => {
            tabOrders.push({
                tabOrder: campo.tabOrder ? campo.tabOrder : index,
                campoNombre: campo.campo,
                ref: React.createRef()
            })
        });

        tabOrders.sort((a, b) => a.tabOrder - b.tabOrder);
        return tabOrders;
    }

    generarTabOrdersDeCamposBusqueda= (busquedaCampos) => {
        this.tabOrders = [];
        busquedaCampos.forEach( (campo, index) => {
            this.tabOrders.push({
                tabOrder: campo.tabOrder ? campo.tabOrder : index,
                campoNombre: campo.campo,
                ref: React.createRef()
            })
        });
        this.tabOrders.sort((a, b) => a.tabOrder - b.tabOrder);
    }

    getTabOrderPorCampoNombre= (campoNombre) => {
        let rows = filtrarConNombreCampo(this.tabOrders, "campoNombre", campoNombre);
        if (rows && rows.length > 0)
            return rows[0];
        else
            return null;
    }

    getRef= (campoNombre) => {
        let tabOrder= this.getTabOrderPorCampoNombre(campoNombre);
        if (tabOrder)
            return tabOrder.ref;
        else
            return null;
    }

    getRefSiguiente= (campoNombreActual) => {
        let refSiguiente= null;
        this.tabOrders.forEach( (tabOrder, index) => {
            if (tabOrder.campoNombre === campoNombreActual){
                if (index < this.tabOrders.length -1)
                    refSiguiente = this.tabOrders[index + 1].ref;
                else
                    refSiguiente= this.tabOrders[0].ref;
            }
        });
        return refSiguiente;
    }

    getRefSiguienteNoNull= (campoNombreActual) => {
        console.log("setFocusSiguienteNoNull");
        let refSiguiente= null;
        this.tabOrders.forEach( (tabOrder, index) => {
            if (tabOrder.campoNombre === campoNombreActual){
                let indexSiguiente= 0;
                if (index < this.tabOrders.length -1)
                    indexSiguiente= index+1;
                refSiguiente = this.tabOrders[indexSiguiente].ref;

                while (refSiguiente.current === null && indexSiguiente !== index){
                    indexSiguiente++;
                    if (indexSiguiente >= this.tabOrders.length -1)
                        indexSiguiente= 0;
                    refSiguiente = this.tabOrders[indexSiguiente].ref;
                }
            }
        });
        return refSiguiente;
    }

    setFocusSiguiente= (campoNombreActual) => {
        let refSiguiente= this.getRefSiguienteNoNull(campoNombreActual); //this.getRefSiguiente(campoNombreActual);
        if (refSiguiente && refSiguiente.current) {
            refSiguiente.current.focus();
        }
    }


    setFocusInicial= () => {
        if (this.focusInicialLlamado === false) {
            //console.log("SETFOCUSINICIAL");
            if (this.tabOrders.length > 0) {
                let refPrimero = this.tabOrders[0].ref;
                if (refPrimero && refPrimero.current) {
                    refPrimero.current.focus();
                }
            }
            this.focusInicialLlamado= true;
        }

    }
}

export default TabOrderManager;